import { render, staticRenderFns } from "./indexHR.vue?vue&type=template&id=56319ed5&scoped=true"
import script from "./indexHR.vue?vue&type=script&lang=js"
export * from "./indexHR.vue?vue&type=script&lang=js"
import style0 from "./indexHR.vue?vue&type=style&index=0&id=56319ed5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56319ed5",
  null
  
)

export default component.exports